<template>
  <div>
    <div style="min-height: 200px">
      <tabela-padrao-prime-vue
        v-model="selecionados"
        :dados="orcamentosConsulta"
        filtro-geral
        class="mt-2"
        :colunas="tabela.colunas"
        sem-paginacao
        paginacao-em-memoria
        :por-pagina="tabela.porPagina"
        :pagina-atual="tabela.paginaAtual"
        :selecionar-apenas-um="!multiplos"
        :filters="filters"
        ajustar-altura-linha
        :mostrar-acoes="false"
        :global-filters="tabela.colunas.map((c) => c.value)"
      />
    </div>
  </div>
</template>
<script>
import { FilterMatchMode } from 'primevue/api';
import helpers from '@common/utils/helpers';
export default {
  props: {
    orcamentosConsulta: { type: Array, default: () => [] },
    multiplos: { type: Boolean, default: true },
    value: { type: [Array, Object], default: null },
  },
  data() {
    return {
      filtro: {
        codigo: '',
      },
      filtroAplicado: { filter: '' },
      selecionados: [],
      tabela: {
        dados: [],
        porPagina: 10,
        paginaAtual: 1,
        colunas: [
          {
            value: 'codigo',
            text: this.$t('modulos.orcamentos.tabela.codigo'),
            sortable: true,
          },
          {
            value: 'dataEmissao',
            text: this.$t('modulos.orcamentos.tabela.data_emissao'),
            sortable: true,
            formatter: (v) => {
              if (v) return helpers.formatarDataBr(v, false);
              return '';
            },
          },
        ],
      },
      filters: {
        global: { value: null, matchMode: FilterMatchMode.CONTAINS },
      },
    };
  },
  computed: {
    EhTelaPequena() {
      return ['sm', 'xs'].includes(this.$vuetify.breakpoint.name);
    },
  },
  watch: {
    value: {
      handler() {
        this.selecionados = this.value;
      },
      immediate: true,
    },
    selecionados: {
      handler() {
        if (Array.isArray(this.selecionados)) {
          this.$emit('input', this.selecionados);
          return;
        }
        this.$emit('input', [this.selecionados]);
      },
    },
  },
  methods: {
    aplicarSelecionado() {
      console.log(this.selecionados);
    },
  },
};
</script>
